import { env as environment } from "../environments";

// Fire-and-forget call, runs in parallel with liveFeedback. Errors are swallowed so the existing flow is never affected.
export const callIntegrityScore = (file, sessionId, fileName) => {
  try {
    const integrityForm = new FormData();
    integrityForm.append("pdfFile", file, fileName);
    integrityForm.append("sessionId", sessionId);

    return fetch(environment.integrityScore, {
      method: "POST",
      body: integrityForm,
    }).catch(() => {});
  } catch (error) {
    return Promise.resolve();
  }
};
